import {
  LacedAvailableCurrencies,
  LacedAvailableLocales,
  LacedAvailableLocations,
  Location,
  LocaleObject,
  CurrencyObject
} from 'types/localisation'

export const generateLocations = (
  countries: Location[],
  location: LacedAvailableLocations
) => {
  return countries
    .map((country: Location) => ({
      value: country.code as LacedAvailableLocations,
      label: country.name
    }))
    .sort((a, b) => {
      if (a.value === location) return -1
      if (b.value === location) return 1

      return 1
    })
}

export const generateLocales = (localeObject: LocaleObject) => {
  return (Object.keys(localeObject) as Array<LacedAvailableLocales>).map(
    (locale) => ({
      value: locale,
      label: localeObject[locale].language
    })
  )
}

export const generateCurrency = (currencyObject: CurrencyObject) => {
  return (Object.keys(currencyObject) as Array<LacedAvailableCurrencies>).map(
    (currency) => ({
      value: currency,
      label: `${currencyObject[currency].symbol} ${currencyObject[currency].name}`
    })
  )
}
